import Yt from "./trigger-condition.js";
export default class lr {
  constructor(t) {
    this.fu = t;
  }
  Jl(t) {
    return null == this.fu || Yt.gu(t[0], this.fu);
  }
  static fromJson(t) {
    return new lr(t ? t.campaign_id : null);
  }
  ss() {
    return this.fu;
  }
}
